/**************************************************************************/
/*** 'Column Selector' implemented By Fahad Akbar(fahadakbar24@gmail.com)**/
/**************************************************************************/

const columnSelectorCtrl = ($scope, $rootScope, $modal, columnSelectionApi) => {
  const openSelectionPopup = () => {
    const saveSelectionHandler = () => {
      if ($scope.isColumnSelectionToBeSaved) {
        const selectionPayload = {
          pageId: $scope.pageId,
          selectedColumnIds: _.pluck(
            _.filter($scope.columnsList, column => column.show),
            ['id']
          ),
        }

        columnSelectionApi.save(selectionPayload)
      }
    }
    $scope.columnSelectPopup = $modal.open({
      templateUrl: 'columnSelectTemplate.html',
      controller: columnSelectorCtrl,
      scope: $scope,
    })

    return $scope.columnSelectPopup.result.finally(saveSelectionHandler)
  }

  const isColumnShown = column => column.show
  const isAnyColumnShown = columnsList => columnsList.some(isColumnShown)
  const mapShownStateWithDefault = column =>
    (column.show = column.show_by_default)
  const showDefaultColumnSelection = columnsList =>
    columnsList.forEach(mapShownStateWithDefault)

  const determineToShowDefaultSelection = columnsList => {
    $scope.$watch(
      'columnsList',
      function(newList, oldList) {
        if (newList && !isAnyColumnShown(newList))
          showDefaultColumnSelection(newList)
      },
      true
    )
  }

  $scope.closeSelectionPopup = () => $scope.columnSelectPopup.close()

  ;(function initialize() {
    $scope.openColumnsPopup = openSelectionPopup
    determineToShowDefaultSelection($scope.columnsList)
  })()
}

export {columnSelectorCtrl}



// WEBPACK FOOTER //
// ./scripts/shared/directives/column-selector/controller.js